import UserTimeTrackingRequests from '../../server/userTimeTracking';
import { addLoading, removeLoading } from './loading';

export const setTimeTracking = (timeTracking) => ({
  type: 'SET_TIME_TRACKING_LIST',
  timeTracking,
});

export const getUserTimeTrackingByDate = (filterStartDate, filterEndDate) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await UserTimeTrackingRequests.getUserTimeTrackingByDate(filterStartDate, filterEndDate);
  } finally {
    dispatch(removeLoading());
  }
};

export const finishUserTimeTracking = (trackingId, reasonCode) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await UserTimeTrackingRequests.finishUserTimeTracking(trackingId, reasonCode);
  } finally {
    dispatch(removeLoading());
  }
};

export const deleteUserTimeTracking = (trackingId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await UserTimeTrackingRequests.deleteUserTimeTracking(trackingId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getProductionOrderTimeTracking = (productionOrderId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await UserTimeTrackingRequests.getProductionOrderTimeTracking(productionOrderId);
  } finally {
    dispatch(removeLoading());
  }
};
